import { render, staticRenderFns } from "./px-page-header.vue?vue&type=template&id=34edfd3c&scoped=true&"
import script from "./px-page-header.vue?vue&type=script&lang=ts&"
export * from "./px-page-header.vue?vue&type=script&lang=ts&"
import style0 from "./px-page-header.vue?vue&type=style&index=0&id=34edfd3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34edfd3c",
  null
  
)

export default component.exports